import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import config from "../../../config";
import NavBarLink from "./navBarLink";

import "./index.css";

const { Item } = Menu;

const MainMenu = ({ mode = "horizontal" }) => (
  <Menu mode={mode} selectedKeys={[1]} className="navbar-menu">
    <Item item={1} className="ant-menu-item-selected">
      <Link to="/" className="external-link navbar-link">
        <FormattedMessage id="header.home" defaultMessage="Domů" />
      </Link>
    </Item>
    <Item item={2}>
      <NavBarLink
        id="header.contact"
        defaultMessage="Kontakt"
        href={config.CONTACT_URL}
      />
    </Item>
    <Item item={3}>
      <NavBarLink
        id="header.news"
        defaultMessage="Novinky"
        href={config.NEWS_URL}
      />
    </Item>
    <Item item={4}>
      <NavBarLink
        id="header.services"
        defaultMessage="Služby"
        href={config.SERVICES_URL}
      />
    </Item>
  </Menu>
);

export default MainMenu;
